import React, { Component } from 'react';
import './PasswordInput.css';

const inputTypes = ['password', 'text'];
const revealButtonTexts = ['SHOW', 'HIDE'];

class PasswordInput extends Component {
  state = {
    showVal: 0,
    showButtonVal: 0,
    passwordVal: this.props.defaultPassword ? this.props.defaultPassword : null
  };

  updateAndTransmitInputVal(evt) {
    this.setState({ passwordVal: evt.target.value });
  }

  render() {
    return (
      <div className="passwordInputContainer">
        <div className="passwordInput">
          {/* autocomplete="new-password" is used to prevent autocompelte from filling the inut will login password */}
          <input
            id={this.props.id}
            defaultValue={this.state.passwordVal}
            onChange={(evt) => {
              this.props.passwordValue(evt.target.value);
              this.updateAndTransmitInputVal(evt);
            }}
            type={inputTypes[this.state.showVal]}
            className="passwordInputBox"
            autoComplete="new-password"
          />
          {this.props.showButton && (
            <button
              type="button"
              aria-controls={this.props.id}
              onClick={() => this.setState({ showVal: this.state.showVal ^ 1 })}
              className="showButton"
            >
              {revealButtonTexts[this.state.showVal]}
            </button>
          )}
        </div>
      </div>
    );
  }
}

export default PasswordInput;
